module.exports = __webpack_public_path__ + "static/img/no4.21cf2623.png";